var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 27,
    viewBox: "0 0 54 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 6l4 4-4 4M30.74 10H20"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#041A32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 1c-5.465 0-5.769 3.16-5.386 7.001C36.497 11.85 39.026 15 41.5 15c2.475 0 5.004-3.15 5.387-6.999C47.268 4.161 46.965 1 41.5 1z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21l-1 6M13 21l1 6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31 27l.458-6.18c.453-3.412 2.48-3.793 2.48-3.793s2.207-.63 4.55-1.027L40 19.56M53 27l-.463-6.18c-.455-3.412-2.494-3.793-2.494-3.793s-2.22-.63-4.577-1.027L44 19.475M36.44 5.306c1.483-1.13 3.116-1.13 4.9 0 1.785 1.129 3.527.773 5.226-1.068M42.007 22L40 19.5l1.994-2.5h.013L44 19.5z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#041A32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1C6.035 1 5.731 4.16 6.114 8.001 6.497 11.85 9.026 15 11.5 15c2.475 0 5.004-3.15 5.387-6.999C17.268 4.161 16.965 1 11.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 27l.458-6.18c.453-3.412 2.48-3.793 2.48-3.793s2.207-.63 4.55-1.027L10 19.56M23 27l-.463-6.18c-.455-3.412-2.494-3.793-2.494-3.793s-2.22-.63-4.577-1.027L14 19.475M6.13 6.999c1.95-1.854 3.687-2.418 5.21-1.693 1.525.725 3.411.882 5.66.47M12.007 22L10 19.5l1.994-2.5h.013L14 19.5z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdStep);
export default __webpack_public_path__ + "static/media/thirdStep.63256b9e31d177e0e99bdc172e403f29.svg";
export { ForwardRef as ReactComponent };